import type { DashboardChipVibe } from "@/dashboard-design-system/DashboardChip/types";

export const tableCellTypeOptions = [
  "text",
  "singleSelect",
  "multiSelect",
  "phoneNumber",
  "email",
  "url",
  "date",
  "datetime",
  "checkbox",
  "monetary",
  "number",
  "quickAction",
  "emphasis",
  "twoLine",
  "chipList",
  "iconText",
] as const;

export type TableCellType = (typeof tableCellTypeOptions)[number];

export interface TableCellChip {
  label: string;
  vibe?: DashboardChipVibe;
}
